import React, { useMemo } from 'react';

import { useIntl } from 'react-intl-next';

import { Day, Header, Weeks } from './styled';
import { type CalendarProps } from './types';
import { generateMonthColumns } from './utils';

const Calendar = ({ children, startEpoch, offset }: CalendarProps) => {
	const intlApi = useIntl();

	const monthColumns = useMemo(
		() => generateMonthColumns({ startEpoch, intlApi, offset }),
		[intlApi, startEpoch, offset],
	);

	return (
		<>
			<Header aria-hidden>
				{monthColumns.map((title) => (
					<Day key={title}>{title}</Day>
				))}
			</Header>
			<Weeks>{children}</Weeks>
		</>
	);
};

export { Calendar };
